<template>
    <div class="home">
      
      <div class="homepage">
        <div class="title">
            <span class="titlespan1">稳健</span>
            <span class="titlespan1">的</span>
            <span class="titlespan2">交易</span>
            <!-- <el-image width="600" src="@/assets/logo.png"></el-image> -->
            <div class="home-img">
                <Image src="https://huas.co/img/home2ok.png" />
            </div>
        </div>
      </div>
   </div>
  </template>
  <script>
   export default {
    data() {
      return {
        src: '@/assets/home2ok.png'
      }
    }
      }
  </script>    
  <style scoped>
  .home{
    display: flex;
    flex-direction: column;
  }
  .homepage{
  width: 2180px;
  height: 1090px;
  background-image: url(@/assets/ht-home.jpg);
  }
  .title{
    padding-left: 10em;
    padding-top: 4em;
    display: block;
    text-align: left;
    color: whitesmoke;
    font-family: '-apple-system,BlinkMacSystemFont,arial,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif';
    font-size: 70px;
  }
  .titlespan1{
display: block;
  }
  .titlespan2{
display: block;
  }
  .home-img{
    margin-left: 8em;
  }
  </style>  